import { Component, OnInit, Input } from "@angular/core";
import { ModalController, NavController } from "@ionic/angular";

@Component({
    selector: "RelaunchInfo",
    templateUrl: "./relaunch-info.page.html",
    styleUrls: ["./relaunch-info.page.scss"],
})
export class RelaunchInfo implements OnInit {
    @Input() line1: string;
    @Input() line2: string = ""
    @Input() btn1Txt:string = ""
    @Input() btn2Txt:string = ""
    constructor(
        public navCtrl: NavController,
        public modalController: ModalController
    ) {}

    ngOnInit() {}

    onProceed(){
       this.modalController.dismiss(true)
    }

    onDismiss() {
        this.modalController.dismiss(false);
    };
}
